<template>
  <div>
    <el-row>
      <el-col :span="24">
        <Header></Header>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <MenuList></MenuList>
      </el-col>
      <el-col :span="20">
        <div style="margin-left: 20px;">
          <div>
            <div style="font-size:18px;padding-top: 20px;font-weight: bold;margin:10px;">
              汇总成绩单使用场景：</div>
            <div style="font-size:16px;padding-top: 10px;">
              将各科成绩合并到一张大的成绩单中，即在一张表中呈现学生的多科成绩。
            </div>
          </div>

          <div>
            <div style="font-size:18px;padding-top: 20px;font-weight: bold;margin:10px;">
              怎么使用这个功能？</div>
            <div style="font-size:16px;padding-top: 10px;margin:10px;">
              看老师的成绩是<span style="color:red;">小程序手机端</span>录入的,还是通过电脑录入到<span style="color:red;">Excel文件</span>中了。
            </div>
          </div>

          <div>
            <div style="font-size:18px;padding-top: 20px;font-weight: bold;margin:10px;">
              用小程序手机端录入的单科成绩怎么合并到总表中？</div>
            <div style="font-size:16px;padding-top: 10px;margin:10px;">
              1.管理总成绩表的老师在系统中新建好一个成绩单;
            </div>
            <div style="font-size:16px;padding-top: 10px;margin:10px;">
              2.将成绩单的协作码告知单科成绩老师;
            </div>
            <div style="font-size:16px;padding-top: 10px;margin:10px;">
              3.单科成绩老师在手机端小程序中用“上传成绩”功能在输入协作码后将单科成绩上传到总表中.
            </div>
          </div>

          <div>
            <div style="font-size:18px;padding-top: 20px;font-weight: bold;margin:10px;">
              把多个单科成绩的Excel文件怎么合并到总表中？</div>
            <div style="font-size:16px;padding-top: 10px;margin:10px;">
              1.管理总成绩表的老师在系统中新建好一个成绩单;
            </div>
            <div style="font-size:16px;padding-top: 10px;margin:10px;">
              2.依次选择单科成绩导入导总表中,系统会自动根据姓名和学号匹配,确保合并正确;
            </div>
            <div style="font-size:16px;padding-top: 10px;margin:10px;">
              3.总表老师导出成绩单备用.
            </div>
          </div>


        </div>
      </el-col>
    </el-row>

  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'

  import '../assets/global.css'

  export default {
    components: {
      MenuList,
      Header
    },
    data() {
      return {

      }
    },
    mounted() {

    },
    created() {

    },
    methods: {

    },
    watch: {

    }
  }
</script>

<style>
  .actionStyle {
    display: flex;
    flex-direction: column;

  }

  :header-cell-style: {
    background: '#E9EEF5';
    color: '#000'
  }

  .actionBarStyle {
    display: flex;
    justify-content: space-between;
  }

  .settingGroupStyle {
    display: flex;
    flex-direction: column;
  }

  .rowStyle {
    display: flex;
    justify-content: left;
    padding-left: 50upx;
  }

  .dateRowStyle {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .imgItemStyle {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .imageStyle {
    display: flex;
    justify-content: center;

  }
</style>



// WEBPACK FOOTER //
// src/components/merge_exam_read_me.vue